<template>
  <div class="system-setting">
    <el-card>
      <template #header>
        <span>系统设置</span>
      </template>
      
      <el-form :model="form" label-width="150px">
        <el-divider>小程序配置</el-divider>
        <el-form-item label="小程序名称">
          <el-input v-model="form.app_name" />
        </el-form-item>
        <el-form-item label="AppID">
          <el-input v-model="form.app_id" />
        </el-form-item>
        <el-form-item label="AppSecret">
          <el-input v-model="form.app_secret" type="password" show-password />
        </el-form-item>
        
        <el-divider>支付配置</el-divider>
        <el-form-item label="微信支付商户号">
          <el-input v-model="form.mch_id" />
        </el-form-item>
        <el-form-item label="支付密钥">
          <el-input v-model="form.pay_key" type="password" show-password />
        </el-form-item>
        
        <el-divider>打印配置</el-divider>
        <el-form-item label="默认打印店名">
          <el-input v-model="form.print_shop_name" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.contact_phone" />
        </el-form-item>
        <el-form-item label="营业时间">
          <el-input v-model="form.business_hours" placeholder="如：08:00-22:00" />
        </el-form-item>
        
        <el-divider>积分配置</el-divider>
        <el-form-item label="充值积分比例">
          <el-input-number v-model="form.integral_ratio" :min="0" :precision="0" />
          <span style="margin-left: 10px; color: #909399">每充值1元获得积分</span>
        </el-form-item>
        <el-form-item label="上传手抄报积分">
          <el-input-number v-model="form.upload_integral" :min="0" />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSave">保存设置</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'SystemSetting',
  setup() {
    const form = ref({
      app_name: '阳光打印超市',
      app_id: '',
      app_secret: '',
      mch_id: '',
      pay_key: '',
      print_shop_name: '阳光打印超市',
      contact_phone: '',
      business_hours: '08:00-22:00',
      integral_ratio: 1,
      upload_integral: 50
    })
    
    const fetchSettings = async () => {
      try {
        const res = await request.get('/api/admin/settings')
        if (res.data) {
          form.value = { ...form.value, ...res.data }
        }
      } catch (error) {
        console.error('获取设置失败')
      }
    }
    
    const handleSave = async () => {
      try {
        await request.post('/api/admin/settings', form.value)
        ElMessage.success('保存成功')
      } catch (error) {
        ElMessage.error('保存失败')
      }
    }
    
    const handleReset = () => {
      fetchSettings()
    }
    
    onMounted(() => {
      fetchSettings()
    })
    
    return {
      form,
      handleSave,
      handleReset
    }
  }
}
</script>

<style scoped>
.system-setting {
  max-width: 800px;
  padding: 8px;
}

.system-setting :deep(.el-divider__text) {
  font-weight: 600;
  color: #409EFF;
  font-size: 14px;
}

.system-setting :deep(.el-form-item__label) {
  font-weight: 500;
}
</style>
